export default {"src":"https://www.bulletproof.co.uk/_next/static/media/question-card-icon.90b7216f.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};